import React, { useCallback } from 'react';
import { TagData } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/Tagging/TagData';

interface CurrentTagProps {
  currentTag: TagData;
  removeTagClick: (value: string) => void;
}

export function CurrentTag({ currentTag, removeTagClick }: CurrentTagProps) {
  const onButtonClick = useCallback(() => {
    removeTagClick(currentTag.Tag);
  }, [removeTagClick, currentTag.Tag]);

  return (
    <li className="dpc-tags-editor__selected-tag">
      <span>{currentTag.Tag}</span>
      <button className="dpc-tags-editor__remove-tag-button" onClick={onButtonClick}></button>
    </li>
  );
}
